import type { IconProps } from '@/types/general'

export const ComboboxArrow = (props: IconProps) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width="25"
		height="25"
		viewBox="0 0 25 25"
		fill="none"
		className={props.className}
	>
		<path
			d="M7.19234 9.15039C7.05411 9.1504 6.91904 9.18883 6.80453 9.26073C6.69002 9.33263 6.60131 9.43471 6.54982 9.55383C6.49833 9.67295 6.48642 9.80366 6.51563 9.92912C6.54483 10.0546 6.6138 10.169 6.71367 10.2578L12.0213 14.972C12.1502 15.0865 12.3217 15.1504 12.5 15.1504C12.6783 15.1504 12.8498 15.0865 12.9787 14.972L18.2863 10.2578C18.3862 10.169 18.4552 10.0546 18.4844 9.92912C18.5136 9.80366 18.5017 9.67295 18.4502 9.55383C18.3987 9.43471 18.31 9.33263 18.1955 9.26073C18.081 9.18883 17.9459 9.1504 17.8077 9.15039H7.19234Z"
			fill="#596773"
		/>
	</svg>
)
